import type { ErrorLog } from "@ezrecipebox/contracts";
import { httpsCallable } from "firebase/functions";
import { getClientFunctions } from "./firebase-client";

export interface GetErrorLogsOptions {
  pageSize?: number;
  startAfterId?: string;
  searchQuery?: string;
  logType?: "error" | "warning" | "info" | "all";
  platform?: string;
  userId?: string;
}

export interface GetErrorLogsResult {
  logs: ErrorLog[];
  lastId: string | null;
  hasMore: boolean;
  total: number;
}

export interface DeleteErrorLogsResult {
  success: boolean;
  deletedCount: number;
}

/**
 * Fetch error logs with optional filters and pagination
 */
export async function getErrorLogs(options: GetErrorLogsOptions = {}): Promise<GetErrorLogsResult> {
  const functions = getClientFunctions();
  if (!functions) {
    throw new Error("Firebase functions are not available");
  }

  const callable = httpsCallable<GetErrorLogsOptions, GetErrorLogsResult>(
    functions,
    "getErrorLogs"
  );

  const result = await callable(options);
  return result.data;
}

/**
 * Delete one or more error logs by ID
 */
export async function deleteErrorLogs(logIds: string[]): Promise<DeleteErrorLogsResult> {
  const functions = getClientFunctions();
  if (!functions) {
    throw new Error("Firebase functions are not available");
  }

  const callable = httpsCallable<{ logIds: string[] }, DeleteErrorLogsResult>(
    functions,
    "deleteErrorLogs"
  );

  const result = await callable({ logIds });
  return result.data;
}
